module.exports = __webpack_public_path__ + "media/images/porque/art-parcele-12x-145eda574446a3082580374135281cee.svg";